import { createContext } from "../utils/createContext.mjs";
const doneCallbacks = /* @__PURE__ */ new WeakMap();
function removeDoneCallback(element) {
  const prevDoneCallback = doneCallbacks.get(element);
  if (prevDoneCallback) {
    element.removeEventListener("motioncomplete", prevDoneCallback);
  }
  doneCallbacks.delete(element);
}
const [injectAnimatePresence, provideAnimatePresence] = createContext("AnimatePresenceContext");
export {
  doneCallbacks,
  injectAnimatePresence,
  provideAnimatePresence,
  removeDoneCallback
};
